exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hotshot[data-v-eb609f9a] {\n  background: -webkit-linear-gradient(45deg, var(--cw-700), var(--cw-alt));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n", ""]);

// exports
